import { RefreshCw } from 'lucide-react';
import React from 'react';

interface GuestPreviewErrorStateProps {
  error: string;
  onRetry: () => void;
}

export const GuestPreviewErrorState: React.FC<GuestPreviewErrorStateProps> = ({
  error,
  onRetry,
}) => {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 px-6 text-center">
      <p className="max-w-md text-sm text-red-600">{error}</p>
      <button
        type="button"
        onClick={onRetry}
        className="inline-flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:border-pos-primary hover:text-pos-primary"
      >
        <RefreshCw size={14} />
        Retry
      </button>
    </div>
  );
};
